import { useTranslation } from "react-i18next";

const H2 = ({ text }) => {
  const { t } = useTranslation();

  return (
    <h2 className="text-center text-4xl font-bold mb-8">
      {t(text)}
    </h2>
  );
};

export default H2;
